<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_order my_style">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <UserLeftMenu :active_menu_index="1" />
        <div class="order_list my_teacher">
          <Table
            :data="teacherData.list"
            style="width: 100%"
            :header-cell-style="{background:'rgba(239,242,249,1)',color:'rgba(40,40,40,1)','text-align':'center'}"
            :cell-style="{'text-align':'center','font-size':'14px'}"
          >
            <TableColumn type="index" label="序号"></TableColumn>
            <TableColumn prop="avatar" label="头像">
              <template slot-scope="scope">
                <span class="av">
                  <img :src="scope.row.avatar" alt class="pic_full" />
                </span>
              </template>
            </TableColumn>
            <TableColumn prop="real_name" label="教师">
              <template slot-scope="scope">
                <span
                  class="hand_point"
                  @click="$router.push(`./teacher-details?id=${scope.row.id}`)"
                >{{scope.row.real_name}}</span>
              </template>
            </TableColumn>
            <TableColumn prop="years" label="教学经验">
              <template slot-scope="scope">{{scope.row.years}}年</template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <div class="pagination pr">
            <Pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage1"
              :page-size="100"
              layout="total, prev, pager, next"
              :total="teacherData.total"
            >></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottom">
      <div class="content pr">
        <span class="gift">
          <img src="../../assets/image/user_center/icon (1).png" alt class="pic_full" />
        </span>
        <span class="free_info">
          每成功推荐一个朋友学习，满足奖励条件后即可获得
          <span class="red">200元充值</span>，奖励可累积哦！
        </span>
        <div class="qr_code">
          <div class="qrcode_img">
            <canvas id="QRCode"></canvas>
          </div>
          <p class="notice_info">
            <span class="wechat_icon">
              <img src="../../assets/image/user_center/icon (2).png" alt class="pic_full" />
            </span>
            <span>扫码分享到微信</span>
          </p>
        </div>
        <button class="call_btn hand_point">查看奖励</button>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import UserLeftMenu from "../common/user_left_menu.vue";
import { Table, TableColumn, Pagination } from "element-ui";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    UserLeftMenu,
    Table,
    TableColumn,
    Pagination
  },
  data: function() {
    return {
      teacherData: ""
    };
  },
  mounted: function() {
    this.getList(1);
    this.get_share_code();
  },
  methods: {
    handleEdit(index, row) {
      window.console.log(index, row);
    },
    handleDelete(index, row) {
      window.console.log(index, row);
    },
    getList(page) {
      //获取老师列表
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/myteachers",
        {
          page: page,
          pagesize: 10
        },
        res => {
          if (res.data.code == 200) {
            self.teacherData = res.data.data;
          }
        }
      );
    },
    get_share_code() {
      //生成分享二维码
      let self = this;
      common.requestFun(self, "get", "/student/recommend_code", {}, res => {
        if (res.data.code == 200) {
          var msg = document.getElementById("QRCode");
          QRCode.toCanvas(
            msg,
            `http://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,
            function(error) {
              console.log(error);
            }
          );
        }
      });
    }
  }
};
</script>
<style scoped src="./user_center_teacher.css"></style>
